var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DebugService from './DebugService';
/**
 * Service for converting Exchange IDs to REST IDs for Graph API calls
 * Handles the conversion of Office.js Exchange IDs to Microsoft Graph REST IDs
 */
class OfficeIdConverterService {
    constructor() { }
    static getInstance() {
        if (!OfficeIdConverterService.instance) {
            OfficeIdConverterService.instance = new OfficeIdConverterService();
        }
        return OfficeIdConverterService.instance;
    }
    /**
     * Convert Exchange ID to REST ID for Graph API calls
     * @param exchangeId The Exchange ID from Office.js
     * @returns Promise<string> The REST ID for Graph API
     */
    convertToRestId(exchangeId) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    Office.context.mailbox.convertToRestId([exchangeId], Office.MailboxEnums.RestVersion.v2_0, (result) => {
                        var _a;
                        if (result.status === Office.AsyncResultStatus.Succeeded) {
                            const restId = (_a = result.value) === null || _a === void 0 ? void 0 : _a[0];
                            DebugService.debug('Converted Exchange ID to REST ID');
                            resolve(restId || exchangeId);
                        }
                        else {
                            DebugService.warn('Failed to convert Exchange ID to REST ID');
                            // Fallback: return the original ID if conversion fails
                            resolve(exchangeId);
                        }
                    });
                }
                catch (error) {
                    DebugService.warn('Error converting Exchange ID to REST ID');
                    // Fallback: return the original ID if conversion fails
                    resolve(exchangeId);
                }
            });
        });
    }
    /**
     * Convert multiple Exchange IDs to REST IDs
     * @param exchangeIds Array of Exchange IDs
     * @returns Promise<string[]> Array of REST IDs
     */
    convertMultipleToRestIds(exchangeIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    Office.context.mailbox.convertToRestId(exchangeIds, Office.MailboxEnums.RestVersion.v2_0, (result) => {
                        if (result.status === Office.AsyncResultStatus.Succeeded) {
                            const restIds = result.value || exchangeIds;
                            resolve(restIds);
                        }
                        else {
                            DebugService.warn('Failed to convert multiple Exchange IDs to REST IDs');
                            // Fallback: return the original IDs if conversion fails
                            resolve(exchangeIds);
                        }
                    });
                }
                catch (error) {
                    DebugService.warn('Error converting multiple Exchange IDs to REST IDs');
                    // Fallback: return the original IDs if conversion fails
                    resolve(exchangeIds);
                }
            });
        });
    }
}
export default OfficeIdConverterService.getInstance();
